import { useEffect } from "react";
import PropTypes from "prop-types";
import { showToast } from "../../../../utils/utils";
import { InvoiceDetails, responseStatus } from "../../../../locales/en";
import { getJobsByIdURL } from "../../../../utils/constants/apiEndPoints";
import privateAxios from "../../../../utils/axiosPrivate";
import {
  PAGE_NAVIGATE_0,
  showToastType
} from "../../../../utils/constants/appConstants";
import { useNavigate } from "react-router-dom";

// Define constants to match backend JobSupervisor constants
const JOB_STATUS = {
  CREATED: "CREATED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};

const XeroInvoiceSync = (props) => {
  const navigate = useNavigate();
  const { jobId, setXeroInvoiceJobId } = props;

  useEffect(() => {
    if (!jobId) return;

    const progressEndpoint = getJobsByIdURL(jobId);
    const interval = setInterval(async () => {
      try {
        const response = await privateAxios.get(progressEndpoint);
        const progressData = response?.data?.data;

        if (!progressData) return;

        if (progressData.status === JOB_STATUS.FAILED) {
          navigate(PAGE_NAVIGATE_0);
        }

        const progressMessage =
          progressData?.message || `${InvoiceDetails.xeroWriteBack.message}`;
        showToast(
          progressMessage,
          progressData.status === JOB_STATUS.IN_PROGRESS
            ? `${responseStatus.info}`
            : `${responseStatus.success}`
        );

        if (
          [JOB_STATUS.COMPLETED, JOB_STATUS.FAILED].includes(
            progressData.status
          )
        ) {
          clearInterval(interval);
          localStorage.removeItem("xeroInvoiceSyncJobId");
          setXeroInvoiceJobId(null);
        }
      } catch (error) {
        showToast(error?.response?.data?.message, showToastType?.error);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [jobId, privateAxios, setXeroInvoiceJobId]);

  return null;
};
XeroInvoiceSync.propTypes = {
  jobId: PropTypes.string,
  setXeroInvoiceJobId: PropTypes.func.isRequired
};

export default XeroInvoiceSync;
